<template lang="pug">
  .authentication-form(v-if="! isAuthenticated")
    .notification.is-info.is-light(v-if="password.success")
      button.delete(type="button" @click="password.success = false; tab = 'signin'")
      | {{ password.success }}
    validation-observer(v-else v-slot="{ invalid }" ref="form")
      form(@submit.prevent="submit")
        .panel(:class="{ 'no-tabs': ! registration }")
          Spinner(v-if="loading" :size="16" :thickness="3")
          .tabs(v-if="multipleTabs")
            ul
              slot(name="prepend-tab")
              li(:class="{ 'is-active': tab === 'signin' }")
                a(href="#" @click.stop.prevent="tab = 'signin'") Anmelden
              li(v-if="registration" :class="{ 'is-active': tab === 'register' }")
                a(href="#" @click.stop.prevent="tab = 'register'") Registrieren
              slot(name="append-tab")
          .box(v-if="tab === 'forgot'")
            .form-field
              validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
                label.label(for="email") E-Mail Adresse
                .control.has-icons-right
                  input#email.input(
                    type="email"
                    name="email"
                    v-model="form.email"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="at")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
          .box(v-if="tab === 'signin'")
            .form-field
              validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
                label.label(for="email") E-Mail Adresse
                .control.has-icons-right
                  input#email.input(
                    type="email"
                    name="email"
                    v-model="form.email"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="at")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
            .form-field
              validation-provider(name="Passwort" rules="required" v-slot="{ errors }")
                label.label(for="password") Passwort
                .control.has-icons-right
                  input#password.input(
                    type="password"
                    name="password"
                    v-model="form.password"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="key")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
          .box(v-else-if="tab === 'register'")
            select-with-validation.select-field(
              rules="required"
              name="Anrede"
              v-model="form.gender"
              :options="genders"
              :multiple="false"
              :searchable="false"
              :allow-empty="false"
              :show-labels="true"
              track-by="value"
              label="label"
              placeholder="bitte wählen..."
              deselect-label="mit Enter abwählen"
              selected-label="ausgewählt"
              select-label="mit Enter auswählen"
            )
            .form-field
              validation-provider(name="Vorname" rules="required" v-slot="{ errors }")
                label.label(for="first_name") Vorname
                .control.has-icons-right
                  input#first_name.input(
                    type="text"
                    name="first_name"
                    v-model="form.first_name"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="user")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
            .form-field
              validation-provider(name="Nachname" rules="required" v-slot="{ errors }")
                label.label(for="last_name") Nachname
                .control.has-icons-right
                  input#last_name.input(
                    type="text"
                    name="last_name"
                    v-model="form.last_name"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="user")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
            //- .form-field
            //-   label.label(for="company") Firma
            //-   .control.has-icons-right
            //-     input#company.input(type="text" name="company" v-model="form.company")
            //-     span.icon
            //-       font-awesome-icon(icon="city")
            .form-field
              validation-provider(
                name="E-Mail Adresse"
                :rules="tab === 'register' ? `required|email|unique-email` : 'required|email'"
                v-slot="{ errors }"
              )
                label.label(for="email") E-Mail Adresse
                .control.has-icons-right
                  input#email.input(
                    type="email"
                    name="email"
                    v-model="form.email"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="at")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
            .form-field
              validation-provider(name="Passwort" rules="required|zxcvbn:3" v-slot="{ errors }")
                label.label(for="password") Passwort
                .control.has-icons-right
                  input#password.input(
                    :type="password.type"
                    name="password"
                    v-model="form.password"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  button.icon(
                    v-if="form.password && password.type === 'password'"
                    type="button" @click="password.type = 'text'"
                  )
                    font-awesome-icon(icon="eye")
                  button.icon(
                    v-else-if="form.password && password.type === 'text'"
                    type="button" @click="password.type = 'password'"
                  )
                    font-awesome-icon(icon="eye-slash")
                  span.icon(v-else)
                    font-awesome-icon(icon="key")
                PasswordStrengthMeter(
                  :password="form.password"
                  @score="score => password.score = score"
                  @feedback="passwordFeedback"
                )
                p.help.is-danger(v-if="password.warning || (errors && errors.length)") {{ password.warning || errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
          .buttons.flex.justify-between(v-if="tab === 'signin'")
            button.button.is-outlined(type="button" @click="tab = 'forgot'") Ich habe mein Passwort vergessen
            button.button(type="submit" :disabled="invalid") {{ signinButtonText }}
          .buttons.flex.justify-between(v-if="tab === 'forgot'")
            button.button.is-outlined(type="button" @click="tab = 'signin'") Abbrechen
            button.button(type="submit" :disabled="invalid") Passwort zurücksetzen Link senden
          .buttons.flex.flex-row-reverse(v-if="tab === 'register'")
            button.button(type="submit" :disabled="invalid") {{ registerButtonText }}
  .member(v-else)
    slot
</template>

<script>
import Vue from 'vue';
import uniqid from 'uniqid';

import store from '@/store';

import { get, cloneDeep } from '@/helpers';

import { mapGetters, mapActions } from 'vuex';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import PasswordStrengthMeter from '@/components/PasswordStrengthMeter';
import SelectWithValidation from '@/components/Partials/SelectWithValidation';

import { translateWarnings } from '@/extensions/restricted-area/helpers/validate';

export default {
    name: 'Authenticate',
    props: {
        registration: {
            type: Boolean,
            default: true
        },
        defaultTab: {
            type: String,
            default: 'signin' // [ signin | register ]
        },
        defaultEmail: {
            type: String,
            default: ''
        },
        signinButtonText: {
            type: String,
            default: 'Anmelden'
        },
        registerButtonText: {
            type: String,
            default: 'Registrieren'
        }
    },
    data() {
        let data = {
            error: false,
            loading: false,
            activeTab: this.defaultTab,
            form: {
                gender: undefined,
                first_name: '',
                last_name: '',
                company: '',
                email: this.defaultEmail,
                password: ''
            },
            password: {
                type: 'password',
                score: 0,
                warning: false,
                success: false,
                suggestions: []
            },
            genders: [
                {
                    value: 'M',
                    label: 'Herr'
                },
                {
                    value: 'F',
                    label: 'Frau'
                },
                {
                    value: 'X',
                    label: 'Sonstiges'
                }
            ]
        };

        return data;
    },
    components: {
        PasswordStrengthMeter,
        ValidationObserver,
        ValidationProvider,
        SelectWithValidation
    },
    watch: {
        tab() {
            this.$refs.form.reset();
        }
    },
    computed: {
        tab: {
            get() {
                let tab = this.activeTab;
                if (!this.registration && this.activeTab === 'register') tab = 'signin';

                return tab;
            },
            set(value) {
                this.activeTab = value;
            }
        },
        multipleTabs() {
            let multipleTabs = false;
            if (this.registration || this.$slots['prepend-tab'] || this.$slots['append-tab']) multipleTabs = true;
            return multipleTabs;
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            isAuthenticated: 'auth/isAuthenticated',
            cms: 'CMS'
        })
    },
    methods: {
        async submit() {
            this.error = false;
            this.loading = true;

            let errorMessage = {
                id: uniqid(),
                title: 'Fehler',
                text: 'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                type: 'error',
                autoclose: 8000
            };

            const valid = await this.$refs.form.validate();
            if (valid && this.recaptchaSiteKey) {
                await this.$recaptchaLoaded();
                try {
                    await this.$recaptcha('auth');

                    let member = cloneDeep(this.form);
                    switch (this.tab) {
                        case 'signin':
                            store
                                .dispatch('auth/signin', { email: this.form.email, password: this.form.password })
                                .then(data => {
                                    this.$emit('authenticated', data);
                                    this.$emit('success', data);
                                    this.updateMember()
                                        .then(() => {
                                            this.$emit('initialized');
                                            this.loading = false;
                                        })
                                        .catch(() => {
                                            this.loading = false;
                                        });
                                    this.resetForm();
                                })
                                .catch(error => {
                                    const message = get(error, 'response.data.debugMessage');
                                    if (message === 'email not verified') {
                                        errorMessage.text =
                                            'Diese E-Mail wurde noch nicht verifiziert.<br>Bitte prüfen Sie Ihren Posteingang und bestätigen Sie Ihre E-Mail Adresse.';
                                        errorMessage.autoclose = false;
                                    } else if (message === 'credentials invalid') {
                                        errorMessage.text =
                                            'Es gibt ein Problem mit Ihren Zugangsdaten.<br>Bitte überprüfen Sie Ihre Angaben.';
                                        errorMessage.autoclose = false;
                                        this.form.password = '';
                                    }
                                    this.addMessage(errorMessage);

                                    this.$emit('authentication-failed');
                                    this.$emit('error');

                                    this.loading = false;
                                });
                            break;
                        case 'register':
                            member.gender = this.form.gender.value;
                            member.cms_id = this.cms.id;

                            store
                                .dispatch('auth/register', member)
                                .then(data => {
                                    this.$emit('registered', data);
                                    this.$emit('success', data);
                                    this.updateMember()
                                        .then(() => {
                                            this.$emit('initialized');
                                            this.loading = false;
                                        })
                                        .catch(() => {
                                            this.loading = false;
                                        });
                                    this.resetForm();
                                })
                                .catch(error => {
                                    console.error(error);

                                    const emailError = get(error, 'response.data.errors.email');
                                    if (emailError) {
                                        errorMessage.text =
                                            'Diese E-Mail Adresse ist bereits vergeben.<br>Möchten Sie sich einloggen?';
                                        this.activeTab = 'signin';
                                    }
                                    this.addMessage(errorMessage);

                                    this.$emit('registration-failed');
                                    this.$emit('error');

                                    this.loading = false;
                                });
                            break;
                        case 'forgot':
                            store
                                .dispatch('auth/sendResetLinkEmail', {
                                    email: this.form.email,
                                    cms_id: parseInt(this.cms.id)
                                })
                                .then(() => {
                                    this.$emit('password-reset-email-sent');
                                    this.resetForm();

                                    this.password.success =
                                        'Sie erhalten in Kürze eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts';
                                })
                                .catch(error => {
                                    console.error(error);

                                    this.addMessage(errorMessage);
                                    this.$emit('password-reset-email-failed');
                                    this.$emit('error');
                                })
                                .finally(() => {
                                    this.loading = false;
                                });
                            break;
                        default:
                            this.loading = false;
                            this.addMessage(errorMessage);
                            break;
                    }
                } catch (error) {
                    console.error(error);
                    this.loading = false;
                    this.addMessage(errorMessage);
                }
            } else {
                this.loading = false;
                this.addMessage(errorMessage);
            }
        },
        resetForm() {
            this.form = {
                gender: undefined,
                name: '',
                company: '',
                email: '',
                password: ''
            };
        },
        passwordFeedback(feedback) {
            // translateSuggestion
            this.password.warning = translateWarnings(feedback.warning);
        },
        ...mapActions({
            updateMember: 'auth/fetchAuthenticatedMember',
            // fetchCategories: 'shop/fetchCategories',
            addMessage: 'message/add'
        })
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, {
                siteKey: this.recaptchaSiteKey,
                loaderOptions: {
                    useRecaptchaNet: true
                }
            });
        }
    }
};
</script>

<style lang="sass" scoped>
.authentication-form .panel .box .select-field::v-deep .form-field
  margin-bottom: 1rem !important
</style>
